var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6924",
    "data-name": "Rect\\xE1ngulo 6924",
    width: 16.387,
    height: 19.814,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Police_Ico",
    "data-name": "Police Ico",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6677",
    "data-name": "Rect\\xE1ngulo 6677",
    width: 36,
    height: 36,
    transform: "translate(0 8)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17501",
    "data-name": "Grupo 17501",
    transform: "translate(9.806 16.445)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19432",
    "data-name": "Trazado 19432",
    d: "M14.311,7.759a.2.2,0,0,1,.046,0,2.294,2.294,0,0,1,1.965,1.719,3.2,3.2,0,0,1,.061.729q-.007,5.623,0,7.269a2.259,2.259,0,0,1-.526,1.516,2.438,2.438,0,0,1-1.177.748,2.1,2.1,0,0,1-.581.075q-2.542,0-11.16,0a8.229,8.229,0,0,1-1.113-.041,2.3,2.3,0,0,1-1.725-1.62A2.641,2.641,0,0,1,0,17.432q0-.776,0-7.371A1.87,1.87,0,0,1,.018,9.79q.027-.182.047-.268A2.293,2.293,0,0,1,.915,8.191a2.223,2.223,0,0,1,1.131-.432.045.045,0,0,0,.041-.045q0-.648,0-1.641a4.972,4.972,0,0,1,.074-.88,8,8,0,0,1,.216-.912q.059-.2.189-.51A6.31,6.31,0,0,1,4.205,1.516,5.814,5.814,0,0,1,7.91,0a5.006,5.006,0,0,1,.682.014,6.02,6.02,0,0,1,1.564.339A6.329,6.329,0,0,1,13.133,2.62a6.059,6.059,0,0,1,1.1,2.829,7.775,7.775,0,0,1,.045,1.132q-.007.284-.013,1.137a.04.04,0,0,0,.045.041M4.16,7.737h8.034a.011.011,0,0,0,.011-.011V6.265A4.068,4.068,0,0,0,8.229,2.11h-.1A4.068,4.068,0,0,0,4.149,6.265V7.727a.011.011,0,0,0,.011.011m4.023,9.191h.444a.387.387,0,0,0,.418-.322.131.131,0,0,0,0-.034q0-.331,0-2.28A.5.5,0,0,1,9.2,13.9a3.564,3.564,0,0,0,.356-.363,1.474,1.474,0,0,0,.258-.44A1.59,1.59,0,0,0,9.7,11.665a1.675,1.675,0,0,0-1.508-.853,1.676,1.676,0,0,0-1.51.849A1.591,1.591,0,0,0,6.557,13.1a1.483,1.483,0,0,0,.257.441,3.558,3.558,0,0,0,.356.363.5.5,0,0,1,.152.392q0,1.949,0,2.28a.154.154,0,0,0,0,.034.387.387,0,0,0,.417.322h.444",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d2ccd9b329eeb8767e5fc8e582decae8.svg";
export { ForwardRef as ReactComponent };